module.exports = __webpack_public_path__ + "static/booking-reference-56d54da96957574d7a4c31a6de90c0d7.svg";